<template>
  <!-- <div class="container"> -->
  <div class="row">
    <div v-if="description" class="col-md-5" v-html="description"></div>
    <div :class="description ? ['col-md-7', 'offset-md-0'] : 'col'">
      <div class="row ps-0" v-for="question in questions" :key="question.id">
        <div v-if="question.label" class="col-12" v-html="question.label"></div>
        <div
          v-if="question.description"
          class="col-12"
          v-html="question.description"
        ></div>

        <div class="col-12 pe-0">
          <div class="form-group" id="likert7-choices-group">
            <!-- TODO: try adding another row with another set of cols above for the top part of the labels? -->
            <fieldset>
              <div
                class="row d-flex justify-content-around"
                :set="
                  (tooltips = [
                    '<h4>Not Achieving Expectations / Critical Development Need</h4><br><ul><li>This rating is reserved for performance that <b>consistently falls below</b> (i.e., almost always, not just frequently) work objectives and requirements in the given job performance area.</li><li>Training and coaching are not likely to correct problems in the performance area with these individuals.</li><li><i>Only about 5% of all employees are expected to be given this rating.</i></li></ul>',
                    '<h4>Partially Achieving Expectations / Definite Development Need</h4><br><ul><li>This rating is reserved for performance that <b>frequently falls below</b> work objectives and requirements in the given job performance area.</li><li>These borderline performers might improve if they were given more direction and supervision in the performance area.</li><li><i>Approximately 15% of all employees are expected to be given this</i></li></ul>',
                    '<h4>Slightly Below Achieving Expectations / Possible Development Need</h4><br><ul><li>These ratings (3, 4, and 5) represent three levels of acceptable performance that <b>consistently meets</b> work objectives and requirements in the given job performance area.</li><li>While employees in these categories may sometimes exceed or fall short of expectations, their overall performance in the area is generally considered &quot;on target.&quot;</li><li><i>The majority of employees (60%) are expected to receive these ratings.</i></li></ul>',
                    '<h4>Achieving Expectations / Neither Strength nor Development Need</h4><br><ul><li>These ratings (3, 4, and 5) represent three levels of acceptable performance that <b>consistently meets</b> work objectives and requirements in the given job performance area.</li><li>While employees in these categories may sometimes exceed or fall short of expectations, their overall performance in the area is generally considered &quot;on target.&quot;</li><li><i>The majority of employees (60%) are expected to receive these ratings.</i></li></ul>',
                    '<h4>Slightly Above Achieving Expectations / Possible Strength</h4><br><ul><li>These ratings (3, 4, and 5) represent three levels of acceptable performance that <b>consistently meets</b> work objectives and requirements in the given job performance area.</li><li>While employees in these categories may sometimes exceed or fall short of expectations, their overall performance in the area is generally considered &quot;on target.&quot;</li><li><i>The majority of employees (60%) are expected to receive these ratings.</i></li></ul>',
                    '<h4>Exceeding Expectations / Definite Strength</h4><br><ul><li>This rating is reserved for performance that <b>frequently exceeds</b> work objectives and requirements in the given job performance area.</li><li>Individuals deserving this rating have no major performance shortcomings in the performance area.</li><li><i>Only 15% of all employees are expected to achieve this rating.</i></li></ul>',
                    '<h4>Greatly Exceeding Expectations / Major Strength</h4><br><ul><li>This rating is reserved for outstanding performance that <b>consistently exceeds</b> (i.e., almost always, not just frequently) work objectives and requirements in the given job performance area.</li><li>For all practical purposes, individuals deserving this rating have no major or minor performance shortcomings in the performance area.</li><li><i>Only about 5% of all employees are expected to achieve this rating.</i></li></ul>',
                  ])
                "
              >
                <div
                  class="col-1 likert-radio-label-vertical-wrapper pl-md-1 pt-3 d-flex align-items-end justify-content-center mb-0"
                  v-for="choice in question.choices"
                  :key="choice"
                >
                  <label
                    class="likert-radio-label-vertical"
                    :for="'input-' + question.id + '-' + choice"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    data-trigger="hover focus"
                    :data-title="tooltips[choice - 1]"
                    data-html="true"
                    data-offset="0, 20"
                  >
                    {{
                      [
                        'Not Achieving Expectations',
                        'Partially Achieving Expectations',
                        'Slightly Below Achieving Expectations',
                        'Achieving Expectations',
                        'Slightly Above Achieving Expectations',
                        'Exceeding Expectations',
                        'Greatly Exceeding Expectations'
                      ][choice - 1]
                    }}
                    <br />
                    <br />
                    {{
                      [
                        'Critical Development Need',
                        'Definite Development Need',
                        'Possible Development Need',
                        'Neither Strength nor Development Need',
                        'Possible Strength',
                        'Definite Strength',
                        'Major Strength'
                      ][choice - 1]
                    }}
                    <br /><br />
                    {{ choice }}
                    <input
                      :id="'input-' + question.id + '-' + choice"
                      class="my-auto"
                      type="radio"
                      :name="'radio-group-' + question.id"
                      v-model="question.response"
                      v-on:change="handleInputCompleted"
                      :value="choice - 1"
                    />
                  </label>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
export default {
  name: 'LikertScaleSupervisorRating7'
}
</script>
